//src/components/CustomerHistory.js

import React from "react";

const getLatestResolution = (logs = []) => {
  if (!logs.length) return null;

  return [...logs].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  )[0];
};

const badgeColor = (status = "") => {
  switch (status.toLowerCase()) {
    case "resolved":
      return "success";

    case "pending":
      return "warning";

    case "in_progress":
      return "primary";

    case "rejected":
      return "danger";

    default:
      return "secondary";
  }
};

const CustomerHistory = ({ loading, history }) => {
  if (loading) {
    return (
      <div className="card shadow-sm border-0 rounded-4 mb-4">
        <div className="card-body text-center py-4">
          <div className="spinner-border text-info" />
          <div className="mt-2">Loading customer history...</div>
        </div>
      </div>
    );
  }

  if (!history) return null;

  const complaints = history.data?.complaints || [];
  const cancellations = history.data?.cancellations || [];

  return (
    <div className="card shadow-sm border-0 rounded-4 mb-4">

      <div className="card-header bg-white">
        <h5 className="mb-0 fw-bold">
          Customer History
        </h5>
      </div>

      <div className="card-body">

        {/* Complaints */}

        {complaints.length > 0 && (
          <>
            <h6 className="fw-bold mb-3 text-info">
              Complaints
            </h6>

            {complaints.map((item) => {
              const latest = getLatestResolution(item.resolutionLog);

              return (
                <div
                  key={item.complaintId}
                  className="border rounded-3 p-3 mb-3"
                >
                  <div className="row">

                    <div className="col-md-3">
                      <small className="text-muted">
                        Complaint ID
                      </small>

                      <div className="fw-semibold">
                        {item.complaintId}
                      </div>
                    </div>

                    <div className="col-md-3">
                      <small className="text-muted">
                        Service
                      </small>

                      <div className="fw-semibold">
                        {item.serviceName}
                      </div>
                    </div>

                    <div className="col-md-2">
                      <small className="text-muted">
                        Status
                      </small>

                      <div>
                        <span
                          className={`badge bg-${badgeColor(item.status)}`}
                        >
                          {item.status.replace("_", " ")}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <small className="text-muted">
                        Latest Update
                      </small>

                      {latest ? (
                        <>
                          <div className="fw-semibold">
                            {latest.comment}
                          </div>

                          <small className="text-muted">
                            {latest.timestamp}
                          </small>
                        </>
                      ) : (
                        <div className="text-muted">
                          No updates yet
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* Cancellations */}

        {cancellations.length > 0 && (
          <>
            <h6 className="fw-bold mt-4 mb-3 text-danger">
              Cancellation Requests
            </h6>

            {cancellations.map((item) => {
              const latest = getLatestResolution(item.resolutionLog);

              return (
                <div
                  key={item.requestId}
                  className="border rounded-3 p-3 mb-3"
                >
                  <div className="row">

                    <div className="col-md-3">
                      <small className="text-muted">
                        Request ID
                      </small>

                      <div className="fw-semibold">
                        {item.requestId}
                      </div>
                    </div>

                    <div className="col-md-3">
                      <small className="text-muted">
                        Service
                      </small>

                      <div className="fw-semibold">
                        {item.serviceName}
                      </div>
                    </div>

                    <div className="col-md-2">
                      <small className="text-muted">
                        Status
                      </small>

                      <div>
                        <span
                          className={`badge bg-${badgeColor(item.status)}`}
                        >
                          {item.status.replace("_", " ")}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <small className="text-muted">
                        Latest Update
                      </small>

                      {latest ? (
                        <>
                          <div className="fw-semibold">
                            {latest.comment}
                          </div>

                          <small className="text-muted">
                            {latest.timestamp}
                          </small>
                        </>
                      ) : (
                        <div className="text-muted">
                          No updates yet
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </>
        )}

        {complaints.length === 0 &&
          cancellations.length === 0 && (
            <div className="alert alert-light border mb-0">
              No previous complaints or cancellation requests found.
            </div>
          )}

      </div>
    </div>
  );
};

export default CustomerHistory;